import Vue from 'vue';
import Vuex from 'vuex';
import VueCookie from "vue-cookie";

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        token: "",
        session:{},
        employee:{},
            //employee其中参数 type
            //sale, 销售
            // support, 技术
            // assistant, 商务
            // product, 产品
            // purchase, 采购
            // inquiry, 询源
            // declarer, 关务
            // other, 其他
    },
    getters: {
        token: state => {
            return state.token;
        },
        session: state => {
            return state.session;
        },
        employee: state => {
            return state.session;
        },
    },
    mutations: {
        GETTOKEN(state, data) {
            state.token = data;
            VueCookie.set("token", data);
            localStorage.setItem("token", data)
        },
        GetSESSION(state, data) {
            state.session = data;
            VueCookie.set("session", data);
        },
        GETEMPLOYEE(state, data) {
            state.employee = data;
            VueCookie.set("employee", data);
        },

    },
    actions: {
        GetToken({ commit }, data) {
            commit("GETTOKEN", data);
        },
        GetSession({ commit }, data) {
            commit("GetSESSION", data);
        },
        GetEmployee({ commit }, data) {
            commit("GETEMPLOYEE", data);
        },
        
    },
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js